// @flow
import { takeLatest, put, call, select, all } from 'redux-saga/effects';
import clientConfig from '~/../parameters/client/config';
import { updateNewsletterNotificationError } from './actions';
import ApiNotifications from '~/sdk/notifications/email/ApiNotifications';
import { notificationApiParamsSelector } from '../selectors';
import { newsletterNotificationsSelector } from './selectors';
import {
  UPDATE_NEWSLETTER_NOTIFICATION,
  DISABLE_NEWSLETTER_NOTIFICATION_FROM_EMAIL,
} from './actionTypes';
import { openSnackbar, openSnackbarError, closeSnackbar } from '../Snackbar/actions';
import messages from './messages';

const notificationsApi = new ApiNotifications(clientConfig.notificationApi);

export function* updateNotificationSaga({ payload }: TrovitAction): Generator<*, *, *> {
  yield put(closeSnackbar());

  const apiParams = yield select(notificationApiParamsSelector);

  try {
    yield call(
      [notificationsApi, notificationsApi.updateNewsletterNotificationActivityStatus],
      apiParams,
      payload
    );
  } catch (error) {
    yield put(openSnackbarError());
    yield put(updateNewsletterNotificationError({ ...payload, active: !payload.active }));
  }
}

export function* disableNewsletterNotificationFromEmailSaga({
  payload: newsletterType,
}: TrovitAction): Generator<*, *, *> {
  yield put(closeSnackbar());

  const notificationUpdate = { type: newsletterType, active: false };

  try {
    const apiParams = yield select(notificationApiParamsSelector);
    yield call(
      [notificationsApi, notificationsApi.updateNewsletterNotificationActivityStatus],
      apiParams,
      notificationUpdate
    );

    yield put(openSnackbar(messages.notificationDeactivated));
  } catch (error) {
    yield put(openSnackbarError());
    const newsletterNotifications = yield select(newsletterNotificationsSelector);
    yield put(
      updateNewsletterNotificationError({
        type: newsletterType,
        active: newsletterNotifications[newsletterType].active,
      })
    );
  }
}

export default function* newsletterNotificationsSagas(): Generator<*, *, *> {
  yield all([
    takeLatest(UPDATE_NEWSLETTER_NOTIFICATION, updateNotificationSaga),
    takeLatest(
      DISABLE_NEWSLETTER_NOTIFICATION_FROM_EMAIL,
      disableNewsletterNotificationFromEmailSaga
    ),
  ]);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/NewsletterNotifications/sagas.js